import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { EIcon } from '@shared/enums/icon.enum';

@Injectable({
  providedIn: 'root',
})
export class CustomIconService {
  private matIconRegistry: MatIconRegistry = inject(MatIconRegistry);
  private domSanitizer: DomSanitizer = inject(DomSanitizer);

  registerIcons() {
    Object.keys(EIcon).forEach(key => {
      const iconName = EIcon[key];
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icon/${iconName}.svg`)
      );
    });
  }
}
